import {
	OPEN_LOADING_PAGE,
	CLOSE_LOADING_PAGE,
	SET_ALERT_MESSAGE,
	SET_PRODUCT_PREVIOUS_ACTION,
	SET_MENU_ACTIVE_ACTION,
	SET_DELETE_PRODUCT_PREVIOUS_ACTION,
	SET_VALUE_SEARCH_PRODUCT_ACTION,
	SET_VALIDATE_LOGIN_FACE_ID_ACTION,
	SET_MESSAGE_CHANGE_PASSWORD
} from "../actions/GlobalAction/actionTypes";

const initialState = {
	isLoading: false,
	isError: false,
	isOpenAlert: false,
	message: "",
	productPrevious: undefined,
	isLoginFaceId: false,
	menuActiveGiftExchange: {
		typeCompany: "",
		menuActive: 0
	},
	valueSearch: "",
	messageChangePassword: {
		statusCode: 0,
		message: ""
	}
};

const globalPageReducer = (state = initialState, action) => {
	switch (action.type) {
		case OPEN_LOADING_PAGE: {
			return {
				...state,
				isLoading: true
			};
		}
		case CLOSE_LOADING_PAGE: {
			return {
				...state,
				isLoading: false
			};
		}
		case SET_ALERT_MESSAGE: {
			return {
				...state,
				isError: action.params.isError,
				isOpenAlert: action.params.isOpenAlert,
				message: action.params.message
			};
		}
		case SET_PRODUCT_PREVIOUS_ACTION: {
			const product = action.params;
			let newArr = state.productPrevious ? state.productPrevious : [];
			newArr.push(product);
			const list = newArr?.map(item => {
				if (item?.id === product?.id) {
					return product;
				} else {
					return item;
				}
			});
			const productPreviousList = list?.filter(
				(item, index) => list?.indexOf(item) === index
			);

			return {
				...state,
				productPrevious: product ? productPreviousList : undefined
			};
		}
		case SET_DELETE_PRODUCT_PREVIOUS_ACTION: {
			return {
				...state,
				productPrevious: action.params
			};
		}
		case SET_MENU_ACTIVE_ACTION: {
			return {
				...state,
				menuActiveGiftExchange: action.params
			};
		}
		case SET_VALUE_SEARCH_PRODUCT_ACTION: {
			return {
				...state,
				valueSearch: action.params
			};
		}

		case SET_VALIDATE_LOGIN_FACE_ID_ACTION: {
			return {
				...state,
				isLoginFaceId: action.params
			};
		}

		case SET_MESSAGE_CHANGE_PASSWORD: {
			return {
				...state,
				messageChangePassword: action.params
			};
		}

		default:
			return state;
	}
};

export default globalPageReducer;
